import {
  React,
  useState,
  memo,
  useCallback,
  useEffect,
  Box,
  Button,
  Select,
  Dialog,
  toast,
  EditChooseMedia,
  ReactPlayer,
  LoadingSpinner,
  useGetAllScreensMutation,
  useGetDurationMutation,
  GetCookie,
} from "../../../Libraries/Post/EditPost/Child/EditPostMiddleForm/index";
import "./editpostmiddleform.css";
const EditPostMiddleForm = (props) => {
  const [getAllScreens, { isLoading }] = useGetAllScreensMutation();
  const [getAllDuration, { isLoading: loading }] = useGetDurationMutation();

  const [opendialog, setopendialog] = useState(false);
  const [Screens, setScreens] = useState([]);
  const [durationoptions, setdurationoptions] = useState([]);

  const handleNewselectedscreen = useCallback(
    (e) => {
      props.handleChangeNewSelectedScreens(e);
    },
    [props]
  );

  const handleChangePosttitle = useCallback(
    (e) => {
      props.handleChangePosttitle(e.target.value);
    },
    [props]
  );

  const handledurationoptions = useCallback(
    (e) => {
      props.handleChangeselectedDuration(e?.value);
    },
    [props]
  );

  const handlesetPostStatus = useCallback(
    (e) => {
      props.handleChangePostStatus(e.target.value);
    },
    [props]
  );

  useEffect(() => {
    const getAllScreensFunc = async () => {
      const layoutsdata = new FormData();
      layoutsdata.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      layoutsdata.append("security_token", await GetCookie("es_token"));
      const res = await getAllScreens(layoutsdata).unwrap();
      if (
        res.connection === "true" &&
        res.message === "Screens available" &&
        res.status === "true"
      ) {
        const so = res.data.map((screensoption) => ({
          label: screensoption.txt_screen_name,
          value: screensoption.ser_screen_id,
        }));
        setScreens(so);
      } else {
        setScreens([]);
      }
    };

    try {
      getAllScreensFunc();
    } catch (error) {
      toast.error(error.status);
      console.log(error);
    }
  }, [getAllScreens]);

  useEffect(() => {
    const getDurationFunc = async () => {
      const layoutsdata = new FormData();
      layoutsdata.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      layoutsdata.append("security_token", await GetCookie("es_token"));
      const res = await getAllDuration(layoutsdata).unwrap();
      if (
        res.status === "true" &&
        res.message === "Durations available" &&
        res.connection === "true"
      ) {
        setdurationoptions(res.data);
      } else {
        setdurationoptions([]);
      }
    };
    try {
      getDurationFunc();
    } catch (error) {
      toast.error(error.status);
      console.log(error);
    }
  }, [getAllDuration]);

  //onDialoghide
  const hideDialog = () => {
    setopendialog(false);
  };

  const mediaselectionfooter = () => (
    <React.Fragment>
      <Button variant="contained" onClick={hideDialog} className="capitalized fs-14 fw-bold">
        Submit
      </Button>
    </React.Fragment>
  );

  return (
    <>
      {isLoading || loading ? <LoadingSpinner /> : null}
      <Box sx={{ flexGrow: 1, mb: 2, ml: 4, mr: 3 }}>
        <div className="row surface-0 border-round p-2">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="w-full mt-2">
              <Select
                isMulti="true"
                options={Screens}
                defaultValue={props?.data?.NewSelectedScreens}
                onChange={handleNewselectedscreen}
                isClearable={true}
                placeholder="Select screen"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                  menuPortal: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                  control: (base) => ({
                    ...base,
                    background: "#1776EE",
                    color: "white",
                  }),
                  placeholder: (defaultStyles) => {
                    return {
                      ...defaultStyles,
                      color: "#ffffff",
                    };
                  },
                  dropdownIndicator: (base) => ({
                    ...base,
                    color: "white", // Custom colour
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: "black",
                    backgroundColor: "red",
                  }),
                }}
              />
            </div>
            <div className="w-full mt-3">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="posttitle"
                  defaultValue={props?.data?.PostTitle}
                  placeholder="Type Post title here"
                  onChange={handleChangePosttitle}
                />
              </div>
            </div>

            {props?.data?.finalfile && (
              <>
                <div className="w-full mt-3">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      readOnly={true}
                      ref={props?.posttype}
                      id="posttype"
                      value={props?.data?.finalfile?.txt_media_file_type}
                    />
                  </div>
                </div>

                <div className="w-full mt-3">
                  <div className="form-group">
                    <Select
                      options={durationoptions}
                      onChange={handledurationoptions}
                      isDisabled={props?.posttype?.current?.value === "Video"}
                      value={durationoptions?.filter(
                        (dur) =>
                          dur.value === props?.data?.selectedDuration && dur
                      )}
                      isClearable={true}
                      placeholder="Select Duration"
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </div>
                </div>
              </>
            )}

            <div className="w-full mt-4">
              <span className="mr-5">Post Status</span>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  value="true"
                  checked={props?.data?.PostStatus === "true"}
                  onChange={handlesetPostStatus}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  Active
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  value="false"
                  checked={props?.data?.PostStatus === "false"}
                  onChange={handlesetPostStatus}
                />
                <label className="form-check-label" htmlFor="inlineRadio2">
                  Non Active
                </label>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="row">
              <div className="col d-flex justify-content-end">
                <Button onClick={() => setopendialog(true)} variant="contained" className="capitalized fs-14 fw-bold">
                  Choose Media
                </Button>
              </div>
            </div>

            <div
              className="d-flex justify-content-center outdivofreactplayer mb-3"
              style={{ height: "240px" }}
            >
              <div className="w-full">
                {props?.data?.finalfile &&
                props?.data?.finalfile?.txt_media_file_type === "Image" ? (
                  <img
                    alt="img"
                    src={props?.data?.finalfile?.txt_media_streaming_link}
                    width="100%"
                    height="100%"
                    style={{
                      border: "dotted",
                      borderRadius: "5px",
                    }}
                  />
                ) : props?.data?.finalfile?.txt_media_file_type === "Video" ? (
                  <ReactPlayer
                    url={props?.data?.finalfile?.txt_media_streaming_link}
                    height="100%"
                    width="100%"
                    controls
                  />
                ) : null}
              </div>
            </div>
          </div>

          <Dialog
            visible={opendialog}
            modal
            style={{ width: "1200px", height: "600px" }}
            breakpoints={{ "960px": "75vw", "640px": "100vw" }}
            header={"Select Media"}
            maximizable={true}
            footer={mediaselectionfooter}
            onHide={hideDialog}
          >
            <EditChooseMedia
              setfinalfile={props?.handleChangefinalfile}
              finalfile={props?.data?.finalfile}
            />
          </Dialog>
        </div>
      </Box>
    </>
  );
};

export default memo(EditPostMiddleForm);
